<template>
  <div style="flex: 1; width: 100%">
    <slot name="content" :scrollHandler="scrollHandler" />
  </div>
</template>

<script setup>
const props = defineProps({
  openAccordion: {
    type: Boolean,
    default: false,
  },
});
const scrollHandler = (key) => {
  const offset = 120;
  const element = document.getElementById(key.value);
  if (!element) {
    return;
  }
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;
  if (props.openAccordion === true) {
    element.setAttribute('data-force-open', 'true');
  }

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
</script>
